export const getAsset = (filename, folder = "") => {
  // If folder is empty, just point to the root of public
  if (folder) {
    return `${process.env.PUBLIC_URL}/${folder}/${filename}`;
  }
  return `${process.env.PUBLIC_URL}/${filename}`;
};
